<!--
    描述：系统布局页面
    时间：2020-04-15
    Created by ws
-->
<template>
	<div class="home-page-layout"
		 :class="[{'w-collapse-layout': isCollapse}, {'no-header':noHeader}]">

		<!-- 页面头部 -->
		<top-header v-if="!noHeader"></top-header>

		<!-- 主体区域 -->
		<div class="home-page-content">
			<div class="right-page-container"
				 :class="{'has-tags': showTags}">

				<!-- 主要页面内容 -->
				<div class="h100">
					<transition name="fade"
								mode="out-in">
						<keep-alive :include="cachedViews">
							<router-view :key="key"/>
						</keep-alive>
						<!-- <router-view></router-view> -->
					</transition>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import topHeader from './components/header'
import leftMenu from './components/leftMenu'
import breadCrumb from './components/breadCrumb'
import tagsView from './components/tagsView'

import { mapState, mapActions } from 'vuex'
export default {
	components: {
		topHeader,
		leftMenu,
		breadCrumb,
		tagsView
	},
	data() {
		return {}
	},
	methods: {
		// 个人信息下拉框事件
		handleCommand(command) {
			switch (command) {
				case 'logOut':
					this.$router.push({
						path: '/login'
					})
					break
				default:
					return
			}
		}
	},
	computed: {
		...mapState('app', {
			isCollapse: state => state.isCollapse
		}),
		...mapState('settings', {
			showTags: state => state.showTags,
		}),
		...mapState('tags', {
			cachedViews: state => state.cacheTags
		}),
		key() {
			return this.$route.name
		},
		// 路由参数
		noHeader() {
			return this.$route.query.noHeader
		}
	}
}
</script>

<style lang="less">
@import url('./index.less');
</style>
